import { Controller } from "@hotwired/stimulus";

// Inline-creates an IngredientTag without leaving the surrounding form.
//
// Targets:
//   - tagInput / tagList: text input + container holding tag checkboxes
//   - errorMessage: shared message element for showing server errors
//
// Values:
//   - tagsUrl: POST endpoint (JSON)
export default class extends Controller {
  static targets = [
    "tagInput",
    "tagList",
    "errorMessage",
  ];

  static values = {
    tagsUrl: String,
  };

  async createTag(event) {
    event.preventDefault();
    const name = (this.tagInputTarget.value || "").trim();
    if (!name) return;

    this.clearError();
    try {
      const payload = await this.postJSON(this.tagsUrlValue, {
        ingredient_tag: { name },
      });
      this.appendTagCheckbox(payload.id, payload.name);
      this.tagInputTarget.value = "";
    } catch (err) {
      this.showError(err.message);
    }
  }

  async postJSON(url, body) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const response = await fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token || "",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      let message = `HTTP ${response.status}`;
      try {
        const data = await response.json();
        if (Array.isArray(data.errors)) message = data.errors.join(", ");
      } catch (_) {}
      throw new Error(message);
    }

    return response.json();
  }

  appendTagCheckbox(id, name) {
    const label = document.createElement("label");
    label.className =
      "label cursor-pointer justify-start gap-2 border border-base-300 rounded-lg px-3 py-2";

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.name = "master_ingredient[ingredient_tag_ids][]";
    checkbox.value = id;
    checkbox.checked = true;
    checkbox.className = "checkbox checkbox-sm";

    const span = document.createElement("span");
    span.className = "label-text";
    span.textContent = name;

    label.appendChild(checkbox);
    label.appendChild(span);
    this.tagListTarget.appendChild(label);
  }

  showError(message) {
    if (!this.hasErrorMessageTarget) return;
    this.errorMessageTarget.textContent = message;
    this.errorMessageTarget.classList.remove("hidden");
  }

  clearError() {
    if (!this.hasErrorMessageTarget) return;
    this.errorMessageTarget.textContent = "";
    this.errorMessageTarget.classList.add("hidden");
  }
}
